import { ChangeDetectionStrategy, Component, computed, inject, Input, OnInit, signal } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25ItemI } from "../../../pojo/S25ItemI";
import { requirement } from "./ev.requirements.component";
import { S25ObjectDetailsService } from "../s25.object.details.service";

@TypeManagerDecorator("s25-ng-event-info")
@Component({
    selector: "s25-ng-event-info",
    template: `
        @if (requirements?.length || canEdit) {
            <label class="req-wrapper"
                >Requirements
                <s25-ng-ev-req [itemId]="itemId" [items]="requirements" [readOnly]="!canEdit"></s25-ng-ev-req>
            </label>
        }
        <div class="info-wrapper">
            @if (eventOwner()) {
                <label>
                    Event Owner
                    <s25-item-contact
                        [modelBean]="{ itemId: +eventOwner().itemId, itemName: eventOwner().itemName }"
                        [includeTypeIcon]="true"
                    ></s25-item-contact>
                </label>
            }
            @if (eventInfo.created) {
                <label>
                    Creation Date
                    <p>{{ eventInfo.created }}</p>
                </label>
            }
            @if (eventInfo.externalId) {
                <label>
                    Alien UID
                    <p>{{ eventInfo.externalId }}</p>
                </label>
            }
            <label>
                Reference
                <p>{{ eventInfo.locator }}</p>
            </label>
            @if (eventInfo.cabinet) {
                <label>
                    Cabinet
                    <p>{{ eventInfo.cabinet }}</p>
                </label>
            }
            @if (eventInfo.folder) {
                <label>
                    Folder
                    <p>{{ eventInfo.folder }}</p>
                </label>
            }
        </div>
    `,
    styles: `
        :host {
            display: block;
            padding: 1rem;

            .info-wrapper {
                display: flex;
                flex-direction: column;
                gap: 10px;
            }

            label {
                display: grid;
                grid-template-columns: 30% 70%;
                align-items: center;
                font-weight: 600;

                * {
                    font-weight: 400;
                }
            }

            .req-wrapper {
                align-items: start;
                margin-bottom: 10px;
            }
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class EventInfoComponent implements OnInit {
    @Input({ required: true }) eventInfo: EventInfo;
    @Input({ required: true }) itemId: number;
    @Input({ required: true }) itemTypeId: number;
    @Input({ required: true }) canEdit: boolean;
    @Input() requirements: requirement[];

    private objectDetailsService = inject(S25ObjectDetailsService);
    eventOwner = this.objectDetailsService.eventOwner;

    ngOnInit() {
        if (this.eventInfo.owner?.itemId) {
            this.objectDetailsService.setEventOwner(this.eventInfo.owner);
        }
    }
}

type EventInfo = {
    created: string;
    locator: string;
    cabinet: string;
    folder: string;
    externalId: string;
    owner?: S25ItemI;
};
